export default "__VITE_PUBLIC_ASSET__068e0ba6__"